import {
  GetParCouponHistoryPayload,
  GetPricingUpdateSchedulePayload,
  GetPricingUpdateSummariesPayload,
  ParCouponHistoryEntry,
  PricingUpdateContact,
  PricingUpdatePreview,
  PricingUpdateRun,
  PricingUpdateSchedule,
  PricingUpdateSchedulePayload,
  PricingUpdateSummary,
  PricingUpdateTradePayload,
  PricingUpdateValuation,
  SavePricingUpdateSchedulePayload,
} from '@pages/Deal/store/pricingUpdates/types';
import { AxiosInstance, AxiosResponse } from 'axios';

import { ApiResponse } from '../../models/ApiResponse';

const BASE = '/v2/deals/pricing-updates';

export default class DealPricingUpdatesAPI {
  client: AxiosInstance;
  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async getSchedule(
    payload: GetPricingUpdateSchedulePayload,
  ): Promise<AxiosResponse<ApiResponse<PricingUpdateSchedule | null>>> {
    return this.client.post(`${BASE}/schedule/`, payload);
  }

  // the deal's GoldVision contacts, offered as recipients
  async getContacts(
    payload: GetPricingUpdateSchedulePayload,
  ): Promise<AxiosResponse<ApiResponse<PricingUpdateContact[]>>> {
    return this.client.post(`${BASE}/contacts/`, payload);
  }

  async getSummaries(
    payload: GetPricingUpdateSummariesPayload,
  ): Promise<AxiosResponse<ApiResponse<PricingUpdateSummary[]>>> {
    return this.client.post(`${BASE}/summaries/`, payload);
  }

  // create when schedule_id is omitted, update otherwise
  async saveSchedule(
    payload: SavePricingUpdateSchedulePayload,
  ): Promise<AxiosResponse<ApiResponse<PricingUpdateSchedule>>> {
    return this.client.post(`${BASE}/schedule/save/`, payload);
  }

  async stopSchedule(
    payload: PricingUpdateSchedulePayload,
  ): Promise<AxiosResponse<ApiResponse<null>>> {
    return this.client.post(`${BASE}/schedule/stop/`, payload);
  }

  // returns the schedule as it stands after the removal
  async removeTrade(
    payload: PricingUpdateTradePayload,
  ): Promise<AxiosResponse<ApiResponse<PricingUpdateSchedule | null>>> {
    return this.client.post(`${BASE}/schedule/remove-trade/`, payload);
  }

  async retryValuation(
    payload: PricingUpdateTradePayload,
  ): Promise<AxiosResponse<ApiResponse<PricingUpdateValuation>>> {
    return this.client.post(`${BASE}/schedule/retry-valuation/`, payload);
  }

  // latest 15 valuations, newest first, failures included
  async getParCouponHistory(
    payload: GetParCouponHistoryPayload,
  ): Promise<AxiosResponse<ApiResponse<ParCouponHistoryEntry[]>>> {
    return this.client.post(`${BASE}/par-coupon-history/`, payload);
  }

  // empty until emails are sent (PMCA-6463)
  async getSendHistory(
    payload: PricingUpdateSchedulePayload,
  ): Promise<AxiosResponse<ApiResponse<PricingUpdateRun[]>>> {
    return this.client.post(`${BASE}/schedule/send-history/`, payload);
  }

  // not built yet (PMCA-6463) - the UI keeps Preview hidden until it is
  async previewEmail(
    payload: PricingUpdateSchedulePayload,
  ): Promise<AxiosResponse<ApiResponse<PricingUpdatePreview>>> {
    return this.client.post(`${BASE}/schedule/preview/`, payload);
  }
}
